const colors = [
    { bg: 'bg-info-100', fg: 'text-info-400' },
    { bg: 'bg-success-100', fg: 'text-success-400' },
    { bg: 'bg-warning-100', fg: 'text-warning-600' },
    { bg: 'bg-danger-100', fg: 'text-danger-400' },
    { bg: 'bg-purple-100', fg: 'text-purple-400' },
    { bg: 'bg-lime-100', fg: 'text-lime-400' },
    { bg: 'bg-brown-100', fg: 'text-brown-400' },
]

export const userColors = (id: string) => {
    let hash = 0
    for (let i = 0; i < id.length; i++) {
        hash = (hash << 5) - hash + id.charCodeAt(i)
    }
    return colors[Math.abs(hash) % colors.length]
}

export const reportingColors = {
    gray700: '#0F0F0F',
    gray600: '#545454',
    gray400: '#AFAFAF',
    gray300: '#E2E2E2',
    gray200: '#F0F0F0',
    blue400: '#276EF1',
}

export const dashboardTagColors = {
    red: { bg: '#FDEEF1', fg: '#FA3C69' },
    yellow: { bg: '#FDF9EC', fg: '#C8A022' },
    blue: { bg: '#E9F5FF', fg: '#3E9DE9' },
    green: { bg: '#EFFAF5', fg: '#62CE9A' },
    grey: { bg: '#F5F5F5', fg: '#999999' },
    purple: { bg: '#F5EFF8', fg: '#8969C2' },
}

export const intToColorString = (color: number) => {
    return '#' + color.toString(16).padStart(6, '0')
}

export const isHexColor = (color?: string) => /^#[0-9a-f]{6}$/i.test(color ?? '')
